import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import HeroPage from './pages/HeroPage';
import RegisterPage from './pages/RegisterPage';
import LoginPage from './pages/LoginPage';
import ShopPage from './pages/ShopPage';
import DescargasPage from './pages/DescargasPage';
import SoportePage from './pages/SoportePage';
import ArmeriaPage from './pages/ArmeriaPage';
import NoticiasPage from './pages/NoticiasPage';
import AdminPage from './pages/AdminPage';
import CuentaPage from './pages/CuentaPage';
import CharacterDetailPage from './pages/CharacterDetailPage';
import TerminosPage from './pages/TerminosPage';
import PrivacidadPage from './pages/PrivacidadPage';
import VotarPage from './pages/VotarPage';
import RecuperarContrasenaPage from './pages/RecuperarContrasenaPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import NotFoundPage from './pages/NotFoundPage';
import NoticiasDetailPage from './pages/NoticiasDetailPage';
import GuidesPage from './pages/GuidesPage';
import SistemasPage from './pages/SistemasPage';
import HousingPage from './pages/HousingPage';
import MythicPlusPage from './pages/MythicPlusPage';
import EncuestaPage from './pages/EncuestaPage';
import './App.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ?? `${window.location.protocol}//${window.location.hostname}:8001`;

function AdminRoute() {
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/auth/me`, { withCredentials: true })
      .then(({ data }) => setStatus(data.role === 'admin' ? 'ok' : 'forbidden'))
      .catch(() => setStatus('forbidden'));
  }, []);

  if (status === 'loading') return null;
  if (status === 'forbidden') return <Navigate to="/login" replace />;
  return <AdminPage />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"          element={<HeroPage />} />
        <Route path="/armeria"   element={<ArmeriaPage />} />
        <Route path="/noticias"  element={<NoticiasPage />} />
        <Route path="/noticias/:slug" element={<NoticiasDetailPage />} />
        <Route path="/primeros-pasos" element={<GuidesPage />} />
        <Route path="/jugabilidad"         element={<SistemasPage />} />
        <Route path="/jugabilidad/housing" element={<HousingPage />} />
        <Route path="/jugabilidad/mythic-plus" element={<MythicPlusPage />} />
        <Route path="/registro"  element={<RegisterPage />} />
        <Route path="/login"     element={<LoginPage />} />
        <Route path="/tienda"    element={<ShopPage />} />
        <Route path="/descargas" element={<DescargasPage />} />
        <Route path="/soporte"   element={<SoportePage />} />
        <Route path="/votar"     element={<VotarPage />} />
        <Route path="/recuperar-contrasena" element={<RecuperarContrasenaPage />} />
        <Route path="/verificar-email" element={<VerifyEmailPage />} />
        <Route path="/admin"     element={<AdminRoute />} />
        <Route path="/cuenta"    element={<CuentaPage />} />
        <Route path="/encuesta"  element={<EncuestaPage />} />
        <Route path="/armeria/:name" element={<CharacterDetailPage />} />
        <Route path="/terminos"  element={<TerminosPage />} />
        <Route path="/privacidad" element={<PrivacidadPage />} />
        <Route path="*"          element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
